module.exports = __webpack_public_path__ + "static/media/4.1f357ca8.png";